export default __webpack_public_path__ + "static/media/banner7.4aa74f4c.jpg";